import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import noImage from './images/no-image.svg';
import Config from '../../../../Config';

const ProductVases = (props) => {
  useEffect(() => {
    if (props.vasList?.length > 0) {
      props.onDisplayProductVas();
      props.vasList.map(function (vas, i) {
        if (vas.isDefault) {
          props.onProductVasChange(vas.id, true);
        }
      });
    }
  }, []);

  return (
    <div className='vas-selection-wrapper'>
      {props.vasList &&
        props.vasList.length > 0 &&
        props.vasList.map(function (vas, i) {
          const extendedImage = vas.extendedImage ? Config.epiBaseUrl + vas.extendedImage : noImage;

          return (
            <>
              <div className='vas-item'>
                <div className='title-wrapper'>
                  <div>
                    <CheckBox checked={vas.isSelected} label={vas.title} id={vas.id} onChange={() => handleOnVasChange(vas, !vas.isSelected)}></CheckBox>
                  </div>
                  <div className='short-description' dangerouslySetInnerHTML={{ __html: vas.shortDescription }}></div>
                </div>
                <div className='price-wrapper'>
                  <Price price={vas.price} priceText={vas.priceText} />
                </div>
                <div className='details-wrapper'>
                  <a className='details' href='javascript: void(0)' onClick={() => { setPopUp(vas.id, true); }}>פרטים</a>
                </div>
              </div>

              <PopUp showPopUp={vas.isOpenPopUp} onClose={() => { setPopUp(vas.id, false); }}>
                <div className='card-popup'>
                  <div className='right'>
                    <div className='card-title'>
                      <Image src={extendedImage} alt='' />
                      <div className='popup-title-wrapper'>
                        <div className='popup-title'>{vas.popUpTitle}</div>
                        <div className='popup-sub-title'>{vas.popUpSubTitle}</div>
                      </div>
                    </div>
                  </div>
                  <div className='left'>
                    <div className='details-wrapper'>
                      <div className='description'>
                        <div className='description-cell'>
                          {vas.textWithIconList &&
                            vas.textWithIconList.length > 0 &&
                            vas.textWithIconList.map(function (item, i) {
                              return (
                                <div className='text-with-icon-wrapper'>
                                  {item.icon && item.icon != '' && (
                                    <div className='icon-wrapper'>
                                      {' '}
                                      <Image src={Config.epiBaseUrl + item.icon} />{' '}
                                    </div>
                                  )}
                                  <div className='text-wrapper' dangerouslySetInnerHTML={{ __html: item.text }}></div>
                                </div>
                              );
                            })}

                          {vas.details && vas.details != '' && <div dangerouslySetInnerHTML={{ __html: vas.details }}></div>}
                          {vas.remark && vas.remark != '' && <div dangerouslySetInnerHTML={{ __html: vas.remark }}></div>}
                          {vas.descriptionURL && vas.descriptionURL != '' && (
                            <div>
                              <a className='terms' href={vas.descriptionURL} target='_blank'>
                                לתקנון החבילה
                              </a>
                            </div>
                          )}
                          <div className='popup-price-wrapper'>
                            <Price price={vas.price} priceText={vas.priceText} />
                          </div>
                        </div>
                      </div>
                      <div className='btn-wrapper'>
                        <div className='btn-cell'>
                          <BtnSubmit formid='catalog-card' onclick={() => handleOnVasChange(vas, true)} text='הוסף'></BtnSubmit>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </PopUp>
            </>
          );
        })}
    </div>
  );

  function handleOnVasChange(vas, isSelected) {
    if (vas.isMandatory) {
      return;
    }
    props.onProductVasChange(vas.id, isSelected);
    props.onSelectProductVas({ id: vas.id, title: vas.title, isSelected: isSelected });
  }
  function setPopUp(id, isOpenPopUp) {
    props.onProductVasPopupChange(id, isOpenPopUp);
  }

};

const Price = (props) => {
  if (props.price == '' || props.price == '0') {
    return (<div className='included'>כלול בחבילה</div>)
  }
  else {
    return (
      <>
        <div className='price'>₪{props.price}</div>
        {props.priceText && props.priceText != '' &&
          <div className='period-time'>{props.priceText}</div>
        }
      </>
    )
  }
}

export default ProductVases;
